import { Exclude, Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';

export class ProjectTaskRawDto {
    taskId: number;
    communityId: number;
    shortDescription: string;
    description: string;
    responsibleUserId: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    dueDate: Date;

    statusCode: string;

    // transient variable
    @Exclude()
    clientPath: string;
}
